import { useState } from "react";

import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import { UsePlanVsActualReport } from "./PlanVsActualReport/UsePlanVsActualReport";
import { COLORS } from "../../constants/colors";
import { useExcelPolling } from "../../hooks/useExcelPolling";
import { getPlanVsActualReport } from "./PlanVsActualReport/PlanVsActualReport_Repo";
import { showToast } from "../../utils/toastUtils";

const PlanVsActualReport = () => {
  const { startPolling } = useExcelPolling();
  const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
  const [excelStatus, setExcelStatus] = useState<string | null>("Loading.");
  const [filterData, setFilterData] = useState({
    start_date: "",
    end_date: "",
    page: 1,
    limit: 10,
    search: "",
    action: "view",
  });

  const {
    data: dataForPlanVS_Actual,
    isLoading,
    isSuccess,
  } = UsePlanVsActualReport({
    enable:
      !!filterData.start_date || !!filterData.end_date || !!filterData.search,
    param: {
      ...(filterData.start_date === ""
        ? {}
        : { startDate: filterData.start_date }),
      ...(filterData.end_date === "" ? {} : { endDate: filterData.end_date }),
      ...(filterData.search === "" ? {} : { search: filterData.search }),
      page: filterData.page,
      limit: filterData.limit,
      action: filterData.action,
    },
  });

  const downloadExcelGet = async () => {
    const param = {
      ...(filterData.start_date === ""
        ? {}
        : { startDate: filterData.start_date }),
      ...(filterData.end_date === "" ? {} : { endDate: filterData.end_date }),
      ...(filterData.search === "" ? {} : { search: filterData.search }),
      page: filterData.page,
      limit: filterData.limit,
      action: "download",
    };

    try {
      setLoadingExcel(true);
      const response = await getPlanVsActualReport(param);
      const { success, fileDownloadId, intervalTime } =
        response.rowData.data || {};
      if (success && fileDownloadId) {
        startPolling(fileDownloadId, intervalTime, {
          onStatusUpdate: (excelStatus: string) => {
            setExcelStatus(excelStatus);
          },
          onSuccess: (url: string) => {
            setLoadingExcel(false);
            setExcelStatus("Loading..");
            const a = document.createElement("a");
            a.href = url;
            a.download = "report.xlsx";
            a.click();
            showToast.success("The file is ready!");
          },
          onFaled: (message: string) =>
            showToast.error(message || "onFalied error in  PlanVSActual report excel"),
          onExpired: (message: string) =>
            showToast.error(message || "onExpired error in   PlanVSActualreport excel"),
          onDeleted: (message: string) =>
            showToast.error(message || "onDeleted error in  PlanVSActualreport excel "),
        });
      }
    } catch (error: any) {
      console.log("Error while downloading excel in PlanVSActual report");
    }
  };

  const handleSearch = (val: any) => {
    setFilterData((prev: any) => ({
      ...prev,
      search: val,
    }));
  };
  const handlePagination = (pageNo: number) => {
    setFilterData((prev: any) => ({
      ...prev,
      page: pageNo,
    }));
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFilterData((prev: any) => ({
      ...prev,
      page: pageNo,
      limit: limit,
    }));
  };

  const handleEndDate = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilterData((prev: any) => ({
      ...prev,
      end_date: e.target.value,
    }));
  };
  const handleStartDate = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilterData((prev: any) => ({
      ...prev,
      start_date: e.target.value,
    }));
  };

  return (
    <div className="p-2">
      <PageHeader
        title="Plan Vs Actual Report"
        buttons={[
          {
            label: loadingExcel
              ? excelStatus
                ? excelStatus.charAt(0).toUpperCase() +
                  excelStatus.slice(1) +
                  ".."
                : ""
              : "Excel",
            onClick: () => downloadExcelGet(),
            color: loadingExcel ? COLORS.disable : COLORS.primary,
            disable: loadingExcel ? true : false,
          },
        ]}
      />
      <BasicDataTable
        Title="Plan Vs Actual Report"
        filterFirstApporach={
          !!filterData.start_date ||
          !!filterData.end_date ||
          !!filterData.search
        }
        dynamicHeightOnRowsPerPage={true}
        data={
          (!isLoading && isSuccess && dataForPlanVS_Actual?.formatedData) || []
        }
        showSpinner={isLoading}
        columns={PlanVsActualReportColumn}
        headerContent={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "10px",
              marginBottom: "15px",
            }}
          >
            <label style={{ color: "black", marginTop: "7px" }}>
              Start Date
            </label>
            <input
              type="date"
              style={{
                padding: "6px 10px",
                border: ".2px solid #ccc",
                fontSize: "14px",
                borderRadius: "4px",
              }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleStartDate(e)
              }
            />
            <label style={{ color: "black", marginTop: "7px" }}>End Date</label>
            <input
              type="date"
              style={{
                padding: "6px 10px",
                border: ".2px solid #ccc",
                fontSize: "14px",
                borderRadius: "4px",
              }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleEndDate(e)
              }
            />
          </div>
        }
        handleSearch={(e: any) => handleSearch(e)}
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        paginationTotalRows={
          dataForPlanVS_Actual?.rowData?.data?.Pagination.TotalCounts || 0
        }
      />
    </div>
  );
};
export default PlanVsActualReport;
const PlanVsActualReportColumn = [
  {
    name: "Employee Code",
    selector: (row: { EmployeeCode?: string }) =>
      row.EmployeeCode ? row.EmployeeCode : "-",
    sortable: true,
  },
  {
    name: "Employee Name",
    selector: (row: { EmployeeName?: string }) =>
      row.EmployeeName ? row.EmployeeName : "-",
    sortable: true,
  },
  {
    name: "Attendance Date",
    selector: (row: { AttendanceDate?: string }) =>
      row.AttendanceDate ? row.AttendanceDate : "-",
    sortable: true,
  },
  {
    name: "Planned Call",
    selector: (row: { PlannedCall?: string }) =>
      row.PlannedCall ? row.PlannedCall : "-",
    sortable: true,
  },
  {
    name: "Completed Call",
    selector: (row: { CompletedCall?: string }) =>
      row.CompletedCall ? row.CompletedCall : "-",
    sortable: true,
  },
];
